import React, { useEffect, useState } from 'react';
import './style.css';
import { useNavigate, useParams } from "react-router-dom";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/joy/CircularProgress';
import ReportIcon from '@mui/icons-material/Report';
import deploymentIcon from '../../../assets/icons/settings.svg';
import deployment from '../../../assets/icons/deploy.svg';
import GetRequest from '../../../service/GetRequest';
import ProfileIntiationLablesContainer from '../../../components/DashboardComponents/ProfileIntiationLablesContainer';
import { Button } from 'primereact/button';
import QRCode from 'qrcode.react';

const IntiateDeploymentPage = ({ setActivePath }) => {

    const navigate = useNavigate();
    const { storeId } = useParams();
    const [open, setOpen] = useState(false);
    const [deployedUrl, setDeployedUrl] = useState();
    const [isDeployed, setIsDeployed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [deployDailogeBoxTitle, setDeployDailogeBoxTitle] = useState("Confirm Deploy?");
    const [deployDescription, setDeployDescription] = useState(" All the changes have been saved. Click continue to initiate your first deployment.");

    useEffect(() => {
        setActivePath("Dashboard");
    });

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setDeployDailogeBoxTitle("Confirm Deploy?");
        setDeployDescription(" All the changes have been saved. Click continue to initiate your first deployment.");
    };

    const handleResponse = () => {
        setIsLoading(false);
        setIsDeployed(true);
    };


    const handleinitiateDeployRequest = async () => {
        setIsLoading(true);
        GetRequest("v1/store-management-service/deploy/store/" + storeId,true)
            .then(response => {
                if (!response || response === undefined) {
                    setIsLoading(false);
                    setDeployDailogeBoxTitle("Deploy Failed");
                    setDeployDescription("Something went wrong, please try again");
                } else {
                    console.log(response);
                    setDeployDailogeBoxTitle("Deployed");
                    setDeployedUrl(response.deploymentUrl);
                    setDeployDescription("Your store has been deployed , you can see the details at: " + response.deploymentUrl);
                    handleResponse();
                }
            })
            .catch(error => {
                setIsLoading(false);
                setDeployDailogeBoxTitle("Deploy Failed");
                console.error("Error fetching store data:", error);
                setDeployDescription(error);
            });
       
    }




    // Assuming 'data' is the parameter name
    return (
        <div className="outlet-container">
            <div className="background-white">
                <div className="background-white-sub-container">                  <br />

                    <ProfileIntiationLablesContainer title="Deployment" description="Initiate Deployment" status={true} icon={deploymentIcon} iconBackgroundColor="#FB9A08" />
                    <br /><br /><br />
                    <div className='centralised-text'>
                        <img
                            loading="lazy"
                            alt="icon"
                            src={deployment} // Use src instead of srcSet if you're not using multiple image sources
                            style={{ height: '150px', width: '150px', alignItems: 'center', opacity: '0.2' }} // Set height and width to adjust the size of the image
                        /></div>
                    <p style={{ textAlign: 'center', opacity: '0.5' }}> Your application is not live yet, please intialise your first deployment</p>
                    <br /><br /><br />
                    <div className='centralised-text'>



                        <Button variant="outlined" onClick={handleClickOpen} label="Deploy your Service" icon="pi pi-cog"/>
              
                        <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            fullWidth="lg"
                        >
                            <DialogTitle id="alert-dialog-title">{isLoading ? "Deploying, Please Wait" : deployDailogeBoxTitle}</DialogTitle>

                            <DialogContent>
                                {isLoading ? (
                                    <div className='centralised-text'>
                                        <CircularProgress color="danger" sx={{ '--CircularProgress-size': '80px' }}>
                                            <ReportIcon color="danger" />
                                        </CircularProgress></div>
                                ) : (
                                    <DialogContentText id="alert-dialog-description">
                                        {deployDescription}
                                    </DialogContentText>
                                )}
                                {deployedUrl && (
                                 
                                        <div className='centralised-text'>
                                            <QRCode value={deployedUrl} />
                                        </div>
                                     
                                      
                      

                )}
                                    </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose} disabled={isLoading} label="Cancel"/>
                                    {isDeployed ? (
                                        <Button onClick={() => navigate("/store")} autoFocus disabled={isLoading} label="Go back to home"/>
                                      
                                    ) : (
                                        <Button onClick={handleinitiateDeployRequest} autoFocus disabled={isLoading} label="Continue" />
                                          
                                    )}

                                </DialogActions>
                        </Dialog>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default IntiateDeploymentPage
